import { ColumnActionsMode } from '@fluentui/react';
import { ColumnData } from 'common/components/SearchBar';
import { commonColumnProps } from 'common/utils/columnUtilities';

export const getColumns = () => {
  const columns: ColumnData[] = [
    {
      key: 'lookupAccount',
      name: 'Account #',
      fieldName: 'lookupAccount',
      minWidth: 200,
      maxWidth: 200,
      ...commonColumnProps,
    },
    {
      key: 'lookupName',
      name: 'Name',
      fieldName: 'lookupName',
      minWidth: 350,
      maxWidth: 350,
      ...commonColumnProps,
    },
    {
      key: 'department',
      name: 'Department',
      fieldName: 'department',
      minWidth: 150,
      maxWidth: 150,
      ...commonColumnProps,
    },
    {
      key: 'travelAccount',
      name: 'Travel Section',
      fieldName: 'travelAccount',
      minWidth: 150,
      maxWidth: 150,
      ...commonColumnProps,
    },
    {
      key: 'action',
      name: '',
      fieldName: 'action',
      minWidth: 50,
      columnActionsMode: ColumnActionsMode.disabled,
      ...commonColumnProps,
      isResizable: false,
    },
  ];
  return columns;
};
